import { CatalogueItem, useCatalogue } from 'lib/catalogues';
import { CatalogueItem as CatalogueItemType } from 'lib/catalogues/types';
import ProductGallerySkeleton from 'lib/sellingProduct/ProductGallery/ProductGallerySkeleton';
import React, { useEffect, useState } from 'react';

interface ProductCatalogueProps {
  catalogueId: string | number;
}

const MAX_SHOWING_PRODUCTS = 9;

const ProductCatalogue = ({ catalogueId }: ProductCatalogueProps) => {
  const { catalogue, isLoading, error } = useCatalogue(catalogueId);
  const [showingProducts, setShowingProducts] = useState<
    Array<CatalogueItemType>
  >([]);

  useEffect(() => {
    // Initially, show the first batch of products
    setShowingProducts(
      (catalogue?.items ?? []).slice(0, MAX_SHOWING_PRODUCTS),
    );
  }, [catalogue?.items]);

  const shouldShowMoreProducts =
    (catalogue?.items?.length ?? 0) > showingProducts.length;

  const showMoreProducts = () => {
    const nextBatch = (catalogue?.items ?? []).slice(
      showingProducts.length,
      showingProducts.length + MAX_SHOWING_PRODUCTS,
    );
    setShowingProducts((prevProducts) => [
      ...prevProducts,
      ...nextBatch,
    ]);
  };

  if (error)
    return (
      <p className="tw-text-center">
        Something went wrong when fetching products.
      </p>
    );

  return (
    <div className="tw-py-4">
      {isLoading ? (
        <ProductGallerySkeleton />
      ) : (
        <React.Fragment>
          {(catalogue?.items?.length ?? 0) > 0 ? (
            <React.Fragment>
              <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-2 lg:tw-gap-5">
                {showingProducts.map((product) => (
                  <CatalogueItem key={product.id} item={product} />
                ))}
              </div>
              {shouldShowMoreProducts && (
                <div className="more-container text-center mt-2 mb-2">
                  <button
                    className="btn btn-outline-darker btn-load-more"
                    onClick={showMoreProducts}
                  >
                    <span>More Good Stuff </span>{' '}
                    <em className="icon-refresh"></em>
                  </button>
                </div>
              )}
            </React.Fragment>
          ) : (
            <p className="tw-italic tw-text-center">
              Something YUMMY is coming soon!
            </p>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default ProductCatalogue;
